import { useFiltersContext } from 'context/filters-context'
import { Button, Container, Home } from './styled'
import { IconHome } from '../../../components/icons/home'
import { Link } from 'react-router-dom'
import { FC } from 'react'
import { useAppContext } from 'context/app-context'

export const Pagination: FC<{ id: string }> = ({ id }) => {
  const { strings } = useAppContext()
  const { filteredData } = useFiltersContext()
  const currentIndex = filteredData.findIndex(p => p.id === id)
  const previousId = currentIndex > 0 ? filteredData[currentIndex - 1].id : ''
  const nextId =
    currentIndex < filteredData.length - 1
      ? filteredData[currentIndex + 1].id
      : ''

  if (currentIndex < 0) {
    return null
  }

  return (
    <Container>
      {previousId ? (
        <Link to={`/detail/${previousId}`}>
          <Button>{strings.pagination_prev}</Button>
        </Link>
      ) : (
        <Button>{strings.pagination_prev}</Button>
      )}
      <Home>
        <Link to="/">
          <IconHome />
        </Link>
      </Home>

      {nextId ? (
        <Link to={`/detail/${nextId}`}>
          <Button $isNext>{strings.pagination_next}</Button>
        </Link>
      ) : (
        <Button $isNext>{strings.pagination_next}</Button>
      )}
    </Container>
  )
}
